// src/services/firebase/config.ts
import { initializeApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';
import { getAnalytics, isSupported, Analytics } from 'firebase/analytics';

import {
  FIREBASE_API_KEY,
  FIREBASE_APP_ID,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_MEASUREMENT_ID,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET,
} from '../../environment';

const firebaseConfig = {
  apiKey: FIREBASE_API_KEY,
  authDomain: FIREBASE_AUTH_DOMAIN,
  projectId: FIREBASE_PROJECT_ID,
  storageBucket: FIREBASE_STORAGE_BUCKET,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
  appId: FIREBASE_APP_ID,
  measurementId: FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Remote Config with settings
export const remoteConfig = getRemoteConfig(app);
remoteConfig.settings = {
  minimumFetchIntervalMillis: 0, // During development, set to 0 for immediate fetches
  fetchTimeoutMillis: 10000,
};

// Set default values
remoteConfig.defaultConfig = {
  buy_tickets_hero_link_variant: 'A',
};

// Initialize Analytics only in browser environment
export let analytics: Analytics | null = null;

// Only initialize analytics in browser environment
if (typeof window !== 'undefined') {
  // Check if analytics is supported in this environment
  isSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
        console.log('Firebase Analytics initialized');
      } else {
        console.log('Firebase Analytics is not supported in this environment');
      }
    })
    .catch((error) => {
      console.error('Error checking Firebase Analytics support:', error);
    });
}

// Log initialization
console.log('Firebase initialized');
